import { Injectable } from '@angular/core';
import { CoinDto } from '../models/coin-dto';

export interface CoinRow {
  // i18n key (iaa.app.coin.*) resolved with the translate pipe in the template.
  label: string;
  value: string;
}

@Injectable({ providedIn: 'root' })
export class CoinService {

  // Flat list of label/value rows for the coin page. Empty fields are dropped so
  // the page only shows what the pipeline actually extracted. Labels are i18n keys
  // (translations live in he.json / en.json), values are the English-only source data.
  getRows(coin: CoinDto): CoinRow[] {
    const defs: { label: string; value?: string | null }[] = [
      { label: 'iaa.app.coin.iaaNumber', value: coin.iaaNumber },
      { label: 'iaa.app.coin.catNo', value: coin.catNo },
      { label: 'iaa.app.coin.ruler', value: coin.ruler },
      { label: 'iaa.app.coin.denomination', value: coin.denomination },
      { label: 'iaa.app.coin.mint', value: coin.mint },
      { label: 'iaa.app.coin.material', value: coin.material },
      { label: 'iaa.app.coin.date', value: coin.coinDate },
      { label: 'iaa.app.coin.weight', value: coin.weight },
      { label: 'iaa.app.coin.diameter', value: coin.diameter },
      { label: 'iaa.app.coin.axis', value: coin.axis },
      { label: 'iaa.app.coin.obverse', value: coin.obverse },
      { label: 'iaa.app.coin.obverseDesign', value: coin.obverseDesign },
      { label: 'iaa.app.coin.obverseLegend', value: coin.obverseLegend },
      { label: 'iaa.app.coin.obverseLegendRead', value: coin.obverseLegendRead },
      { label: 'iaa.app.coin.obverseLegendRestored', value: coin.obverseLegendRestored },
      { label: 'iaa.app.coin.obverseCondition', value: coin.obverseCondition },
      { label: 'iaa.app.coin.obverseFieldMarks', value: coin.obverseFieldMarks },
      { label: 'iaa.app.coin.reverse', value: coin.reverse },
      { label: 'iaa.app.coin.reverseDesign', value: coin.reverseDesign },
      { label: 'iaa.app.coin.reverseLegend', value: coin.reverseLegend },
      { label: 'iaa.app.coin.reverseLegendRead', value: coin.reverseLegendRead },
      { label: 'iaa.app.coin.reverseLegendRestored', value: coin.reverseLegendRestored },
      { label: 'iaa.app.coin.reverseCondition', value: coin.reverseCondition },
      { label: 'iaa.app.coin.reverseFieldMarks', value: coin.reverseFieldMarks },
      { label: 'iaa.app.coin.locus', value: coin.locus },
      { label: 'iaa.app.coin.basket', value: coin.basket },
      { label: 'iaa.app.coin.reference', value: coin.reference },
    ];
    return defs
      .filter(d => d.value != null && d.value !== '')
      .map(d => ({ label: d.label, value: d.value as string }));
  }
}
